// @ts-ignore
import { get } from 'lodash'
// @ts-ignore
import { List } from 'immutable'
import { browserName } from 'react-device-detect'

import * as types from './actionTypes'
// @ts-ignore
import { createRequestActions } from 'helpers'
import { createAction } from 'redux-actions'
// @ts-ignore
import { createRequestActions as request } from '../../actionCreators/createRequestActions'
// @ts-ignore
import { ORGANIZATIONS_EDIT_FORM_NAME } from 'app/constants/organizations'
import {
  FormType,
  IAdminOrganizationUsersResendProtracks,
  IAdminOrganizationUsersResendProtracksParams,
  ICheckDomain,
  ICreateOneSignalApplication,
  ICreateOrUpdateSprintForOrganization,
  ICreateOrUpdateSprintForOrganizationParams,
  IDeleteOrganizationUserBulk,
  IDeleteSprintByIdPayload,
  IDisableOrganizationsForm,
  IEnableOrganizationsForm,
  IFetchAllSuccess,
  IFetchAvailableProTrackLevelsForSelectedOrgPayload,
  IFetchIdRequest,
  IFetchOrDeleteSprintByIdParams,
  IFetchOrganizationById,
  IFetchOrganizationProtrackLevelChanges,
  IFetchSprintByIdPayload,
  IFetchSwitchProTrackLevelsHistory,
  IFilterBy,
  IFilterUsersBy,
  IFilterUsersByTeam,
  IGetLoginLinkAsUser,
  IGetUserProtrackActivities,
  IGetUserProtrackActivitiesParams,
  IGetUserProtracksRequest,
  IHandleOrganization,
  IInvitesFormSubmit,
  IManageUsers,
  IPostPartnersLinks,
  IPostPartnersLinksParams,
  IReinviteOrganizationUsers,
  IRemoteSubmitForm,
  IResendOrganizationUsersSelectProTrack,
  IResendSurvey,
  IResendSurveyParams,
  IResendUserNotification,
  IResendUserNotificationParams,
  ISelectFirstUsersOrganization,
  ISelectPage,
  ISelectUsersOrganization,
  ISelectUsersOrganizationParams,
  ISelectUsersPage,
  ISetFormType,
  ISetOrganizationPendingGetOrganizationUsers,
  ISetOrganizationUsersFilterPayload,
  ISetPendingObjectPayload,
  ISetReviewsLinkPayload,
  ISetReviewsLinkParams,
  ISortBy,
  ISortUsersBy,
  ISwitchUsersTab,
  IToggleOrganizationSprints,
  IToggleOrganizationSprintsParams,
  IUpdateOrganizationProtrackLevelTeamsParams,
  IUpdateOrganizationProtrackLevelTeamsPayload,
  IUpdateOrganizationProtrackLevelTeamsSuccessForMicroactionsPayload,
  IUpdateOrganizationUserRoles,
  IUpdateOrganizationUserRolesParams,
  IUpdateUserEmail,
  IUpdateUserEmailParams,
  IUpdateUserNotificationTypesParams,
  IUpdateUserNotificationTypesPayload,
  IUpdateUserPhoneNumber,
  IUpdateUserPhoneNumberParams,
  IUpdateUserProtrackActivity,
  IUpdateUserProtrackActivityParams,
  IUpdateUserTeamsParams,
  IUpdateUserTeamsPayload,
  IUpdateUserTeamsSuccessForMicroactionsOrReviews,
  IUploadLogoError,
  IUploadLogoRequest,
  IUploadLogoSuccess,
} from './interfaces/action.interfaces'
import { IOrganization } from './interfaces/common.interfaces'
import { Organization } from 'store/records/organization'
// @ts-ignore
import * as REQUESTS from 'app/constants/requests'
import { IFetchUsers, IFetchUsersByStatus, ITriggerFetchUsers } from './interface'
// @ts-ignore
import { createPhoneFormName } from 'app/domains/common/UsersTable/Row/PhoneForm'

export const adminOrganizationUsersResendProtracks = request(
  'ADMIN_ORGANIZATION_USERS_RESEND_PROTRACKS',
  (userData: IAdminOrganizationUsersResendProtracksParams): IAdminOrganizationUsersResendProtracks => ({
    request: {
      url: '/users/select-protrack-resend',
      method: 'POST',
      data: userData,
    },
  })
)

export const fetchAllRequest = () => ({
  type: types.ORGANIZATIONS_FETCH_ALL_REQUEST,
})

export const fetchAllSuccess = (data: Organization[]): IFetchAllSuccess => ({
  type: types.ORGANIZATIONS_FETCH_ALL_SUCCESS,
  payload: { data },
})

export const createOrganization = request('ORGANIZATIONS/CREATE', (data: IOrganization): IHandleOrganization => ({
  request: {
    url: '/organizations',
    method: 'POST',
    data,
  },
  form: ORGANIZATIONS_EDIT_FORM_NAME,
  success: 'Organization was successfully created!',
}))

export const fetchIdRequest = request('ORGANIZATIONS/FETCH_ID_REQUEST', (id: number): IFetchIdRequest => {
  return {
    request: {
      url: `/organizations/${id}`,
      data: {
        id,
      },
    },
  }
})

export const updateOrganization = request('ORGANIZATIONS/UPDATE', (data: IOrganization): IHandleOrganization => ({
  request: {
    url: `/organizations/${data.id}`,
    method: 'PUT',
    data,
  },
  form: ORGANIZATIONS_EDIT_FORM_NAME,
  success: 'Organization was successfully updated!',
}))

export const checkDomain = createAction(
  types.ORGANIZATIONS_CHECK_DOMAIN_REQUEST,
  (domain: string, formName: ORGANIZATIONS_EDIT_FORM_NAME): ICheckDomain => ({
    domain,
    formName,
  })
)

export const uploadLogoRequest = (file: File, mime: MimeType, ext: string, fieldName: string): IUploadLogoRequest => ({
  type: types.ORGANIZATIONS_UPLOAD_LOGO_REQUEST,
  payload: { file, mime, ext, fieldName },
})

export const uploadLogoSuccess = (url: string): IUploadLogoSuccess => ({
  type: types.ORGANIZATIONS_UPLOAD_LOGO_SUCCESS,
  payload: { url },
})

export const uploadLogoError = (): IUploadLogoError => ({
  type: 'ORGANIZATIONS/UPLOAD_LOGO_ERROR',
})

export const selectPage = (page: number): ISelectPage => ({
  type: types.ORGANIZATIONS_SELECT_PAGE,
  payload: {
    page,
  },
})

export const sortBy = (by: string, desc: boolean): ISortBy => ({
  type: types.ORGANIZATIONS_SORT_BY,
  payload: {
    by,
    desc,
  },
})

export const filterBy = (by: string): IFilterBy => ({
  type: types.ORGANIZATIONS_FILTER_BY,
  payload: {
    by,
  },
})

export const updateOrganizationUserRoles = request(
  'ORGANIZATIONS/UPDATE_USER_ROLES',
  ({ organizationId, users }: IUpdateOrganizationUserRolesParams): IUpdateOrganizationUserRoles => ({
    request: {
      url: `/organizations/${organizationId}/users/roles/bulk`,
      method: 'PUT',
      data: { users },
    },
    success: 'Roles updated successfully',
  })
)

export const getLoginLinkAsUser = createAction(
  'ORGANIZATIONS/GET_LOGIN_LINK_AS_USER',
  (payload: IGetLoginLinkAsUser): IGetLoginLinkAsUser => payload
)

export const selectUsersPage = (page: number): ISelectUsersPage => ({
  type: types.ORGANIZATIONS_USERS_SELECT_PAGE,
  payload: { page },
})

export const sortUsersBy = (by: string, desc: boolean): ISortUsersBy => ({
  type: types.ORGANIZATIONS_USERS_SORT_BY,
  payload: {
    by,
    desc,
  },
})

export const filterUsersBy = (by: string): IFilterUsersBy => ({
  type: types.ORGANIZATIONS_USERS_FILTER_BY,
  payload: {
    by,
  },
})

export const filterUsersByTeam = (team: string): IFilterUsersByTeam => ({
  type: types.ORGANIZATIONS_USERS_FILTER_BY_TEAM,
  payload: {
    team,
  },
})

export const switchUsersTab = (tab: string): ISwitchUsersTab => ({
  type: types.ORGANIZATIONS_USERS_SWITCH_TAB,
  payload: {
    tab,
  },
})

export const selectUsersOrganization = ({ id, title }: ISelectUsersOrganizationParams): ISelectUsersOrganization => ({
  type: types.ORGANIZATIONS_SELECT_USERS_ORGANIZATION,
  payload: {
    id,
    name: title,
  },
})

export const setFormType = (type: FormType): ISetFormType => ({
  type: types.ORGANIZATIONS_FORM_SET_FORM_TYPE,
  payload: {
    type,
  },
})

export const remoteSubmitForm = (): IRemoteSubmitForm => ({
  type: types.ORGANIZATIONS_REMOTE_FORM_SUBMIT,
})

export const enableOrganizationsForm = (): IEnableOrganizationsForm => ({
  type: types.ORGANIZATIONS_FORM_ENABLE,
})

export const disableOrganizationsForm = (): IDisableOrganizationsForm => ({
  type: types.ORGANIZATIONS_FORM_DISABLE,
})

export const selectFirstUsersOrganization = (): ISelectFirstUsersOrganization => ({
  type: types.ORGANIZATIONS_USERS_SELECT_FIRST_ORGANIZATION,
})

export const invites = {
  post: createRequestActions({
    request: types.INVITES.POST.REQUEST,
    success: types.INVITES.POST.SUCCESS,
    fail: types.INVITES.POST.FAIL,
  }),
}

export const invitesFormSubmit = (values: any, isBulk: boolean): IInvitesFormSubmit => ({
  type: types.INVITES_FORM_SUBMIT,
  payload: {
    values,
    isBulk,
  },
})

export const adminOrganizationUsers = {
  get: createRequestActions({
    request: types.ADMIN_ORGANIZATION_USERS.GET.REQUEST,
    success: types.ADMIN_ORGANIZATION_USERS.GET.SUCCESS,
    fail: types.ADMIN_ORGANIZATION_USERS.GET.FAIL,
  }),
  post: createRequestActions({
    request: types.ADMIN_ORGANIZATION_USERS.POST.REQUEST,
    success: types.ADMIN_ORGANIZATION_USERS.POST.SUCCESS,
    fail: types.ADMIN_ORGANIZATION_USERS.POST.FAIL,
  }),
}

export const adminOrganizationUsersResendInvite = {
  post: createRequestActions({
    request: types.ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.REQUEST,
    success: types.ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.SUCCESS,
    fail: types.ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.FAIL,
  }),
}

export const setOrganizationPendingGetOrganizationUsers = (
  pending: boolean
): ISetOrganizationPendingGetOrganizationUsers => ({
  type: types.ORGANIZATION_SET_PENDING_GET_ORGANIZATION_USERS,
  payload: {
    pending,
  },
})

export const createOneSignalApplication = request(
  'ORGANIZATIONS/CREATE_ONE_SIGNAL_APPLICATION',
  (id: number): ICreateOneSignalApplication => ({
    request: {
      url: `/organizations/${id}/one-signal`,
      method: 'POST',
    },
  })
)

export const deleteOrganizationUserBulk = request(
  'ORGANIZATIONS/USER_DELETE_BULK',
  ({ userIds, from }: IDeleteOrganizationUserBulk) => ({
    request: {
      url: `/users`,
      method: 'DELETE',
      data: { userIds, from },
    },
    success: 'User(s) deleted successfully.',
  })
)

export const getUserProtracks = request(
  'ORGANIZATIONS/USER_PROTRACKS/GET',
  (userId: number): IGetUserProtracksRequest => ({
    request: {
      url: `users/${userId}/protracks`,
    },
  })
)

export const getUserProtrackActivities = request(
  'ORGANIZATIONS/USER_ACTIVITIES/GET',
  (params: IGetUserProtrackActivitiesParams): IGetUserProtrackActivities => ({
    request: {
      url: `users/${params.userId}/protracks/${params.levelId}/activities`,
    },
  })
)

export const updateUserProtrackActivity = request(
  'ORGANIZATIONS/USER_ACTIVITY/PUT',
  (params: IUpdateUserProtrackActivityParams): IUpdateUserProtrackActivity => {
    const { userId, levelId, previousActionType, newActionType, reason, activityId } = params
    return {
      request: {
        url: `users/${userId}/protracks/${levelId}/activities/${activityId}`,
        method: 'PUT',
        data: {
          previousActionType,
          newActionType,
          reason,
        },
      },
    }
  }
)

export const setOrganizationUsersFilter = createAction(
  'ORGANIZATIONS/SET_USER_FILTER',
  (value: string): ISetOrganizationUsersFilterPayload => ({ value })
)

export const reinviteOrganizationUsers = request(
  'ORGANIZATIONS/USERS_REINVITE/POST',
  ({ organizationId, tabType, team, notificationType, search }): IReinviteOrganizationUsers => ({
    request: {
      url: 'users/invitation-resend/bulk',
      method: 'POST',
      params: { organizationId, tabType, team, notificationType, search },
    },
    success: (res) => `${get(res, 'data.emails.length')} users successfully reinvited.`,
  })
)

export const resendOrganizationUsersSelectProTrack = request(
  'ORGANIZATIONS/USERS_RESEND_SELECT_PROTRACK/POST',
  ({ organizationId, tabType, team, notificationType, search }): IResendOrganizationUsersSelectProTrack => ({
    request: {
      url: 'users/select-protrack-resend/bulk',
      method: 'POST',
      params: { organizationId, tabType, team, notificationType, search },
    },
    success: (res) => `Select ProTrack email sent to ${get(res, 'data.emails.length')} users.`,
  })
)

export const updateUserPhoneNumber = request(
  'ORGANIZATIONS/USER_PHONE',
  (data: IUpdateUserPhoneNumberParams): IUpdateUserPhoneNumber => ({
    request: {
      url: `users/${data.id}`,
      method: 'PUT',
      data: { phone: data.phone, phoneISO: data.phoneISO },
    },
    form: createPhoneFormName(data.id),
    success: "Updating user's phone number was successfully",
  })
)

export const updateUserEmail = request(
  'ORGANIZATIONS/USER_EMAIL',
  ({ userId, email }: IUpdateUserEmailParams): IUpdateUserEmail => ({
    request: {
      url: `users/${userId}`,
      method: 'PUT',
      data: { email },
    },
    fail: "Updating user's email was failed",
    success: "Updating user's email was successfully",
  })
)

export const updateUserTeams = request(
  'ORGANIZATIONS/USER_TEAMS',
  (data: IUpdateUserTeamsParams): IUpdateUserTeamsPayload => ({
    request: {
      url: `users/${data.id}`,
      method: 'PUT',
      data: { teams: data.teams },
      pendingObject: { teams: List(data.teams), userId: data.id, scope: data.scope },
    },
    fail: "Updating user's teams was failed",
    success: "Updating user's teams was successfully",
  })
)

export const updateUserTeamsSuccessForMicroactions = createAction(
  'ORGANIZATIONS/USER_TEAMS_SUCCESS_FOR_MICROACTIONS',
  (data: IUpdateUserTeamsSuccessForMicroactionsOrReviews): IUpdateUserTeamsSuccessForMicroactionsOrReviews => data
)

export const updateUserTeamsSuccessForReviews = createAction(
  'ORGANIZATIONS/USER_TEAMS_SUCCESS_FOR_REVIEWS',
  (data: IUpdateUserTeamsSuccessForMicroactionsOrReviews): IUpdateUserTeamsSuccessForMicroactionsOrReviews => data
)

export const updateOrganizationProtrackLevelTeams = request(
  'ORGANIZATIONS/PROTRACK_LEVEL_TEAMS',
  (data: IUpdateOrganizationProtrackLevelTeamsParams): IUpdateOrganizationProtrackLevelTeamsPayload => {
    return {
      request: {
        url: `/organizations/${data.organizationId}/protrack-levels/${data.id}`,
        method: 'PUT',
        data: { teams: data.teams },
        pendingObject: {
          teams: List(data.teams),
          proTrackLevelId: data.id,
          organizationId: data.organizationId,
          scope: data.scope,
        },
      },
      fail: "Updating ProtrackLevel's teams was failed",
      success: "Updating ProtrackLevel's teams was successfully",
    }
  }
)

export const updateOrganizationProtrackLevelTeamsSuccessForMicroactions = createAction(
  'ORGANIZATIONS/PROTRACK_LEVEL_TEAMS_SUCCESS_FOR_MICROACTIONS',
  (
    data: IUpdateOrganizationProtrackLevelTeamsSuccessForMicroactionsPayload
  ): IUpdateOrganizationProtrackLevelTeamsSuccessForMicroactionsPayload => data
)

export const updateUserNotificationTypes = request(
  'ORGANIZATIONS/USER_UPDATE',
  (data: IUpdateUserNotificationTypesParams): IUpdateUserNotificationTypesPayload => ({
    request: {
      url: `users/${data.id}`,
      method: 'PUT',
      data: { notificationType: data.notificationTypes, browser: browserName },
      pendingObject: data.pendingObject,
    },
    fail: "Updating user's notification types was failed",
    success: "Updating user's notification types was successfully",
  })
)

export const fetchOrganizationById = request(
  'ORGANIZATIONS/GET_ORG_BY_ID',
  (organizationId: number): IFetchOrganizationById => {
    return {
      request: {
        url: `organizations/${organizationId}`,
        pendingObject: { organizationId },
      },
    }
  }
)

export const resendUserNotification = request(
  'ORGANIZATIONS/RESEND_USER_NOTIFICATION',
  (data: IResendUserNotificationParams): IResendUserNotification => ({
    request: {
      url: `users/${data.id}/notification-resend`,
      method: 'POST',
      data: { type: data.type },
      pendingObject: data.pendingObject,
    },
    fail: "Resend user's notification was failed",
    success: "Resend user's notification was successfully",
  })
)

export const resendSurvey = request('ORGANIZATIONS/RESEND_SURVEY', (data: IResendSurveyParams): IResendSurvey => ({
  request: {
    url: `users/${data.id}/resend-survey/${data.userProTrackLevelId}`,
    method: 'POST',
    data: { type: data.type },
    pendingObject: data.pendingObject,
  },
  fail: 'Resend survey was failed',
  success: 'Resend survey was successfully',
}))

export const setReviewsSurveyId = request(
  types.ORGANIZATION_SET_REVIEWS_SURVEY_ID,
  ({ reviewsSurveyId, organizationId }: ISetReviewsLinkParams): ISetReviewsLinkPayload => ({
    request: {
      url: `organizations/${organizationId}/review-survey`,
      method: 'POST',
      data: { reviewsSurveyId },
    },
    helper: { organizationId, reviewsSurveyId },
    success: 'Successfully saved survey links',
  })
)

export const setPendingObject = createAction(
  types.ORGANIZATIONS_SET_PENDING_OBJECT,
  (payload: ISetPendingObjectPayload): ISetPendingObjectPayload => payload
)

export const fetchAvailableLanguages = createAction(types.FETCH_AVAILABLE_LANGUAGES, (payload: any): any => payload)

export const setAvailableLanguages = createAction(types.SET_AVAILABLE_LANGUAGES, (payload: any): any => payload)

export const fetchAvailableProTrackLevelsForSelectedOrg = request(
  'ORGANIZATIONS/USERS/FETCH_AVAILABLE_PROTRACKLEVELS_FOR_SELECTED_ORGANIZATION',
  (orgId: number): IFetchAvailableProTrackLevelsForSelectedOrgPayload => {
    return {
      request: {
        url: `/organizations/${orgId}/protrack-levels`,
      },
    }
  }
)

// data is
// {
//   entireOrg: bool,
//   teams: [string],
//   proTrackLevelId: number,
//   emails: [string],
//   organizationId: number,
// }
export const manageUsers = createAction('ORGANIZATIONS/USERS/MANAGE', (data: IManageUsers): IManageUsers => data)

export const fetchSwitchProTrackLevelsHistory = request(
  'ORGANIZATIONS/USERS/FETCH_PROTRACKLEVELS_HISTORY',
  (organizationId: number): IFetchSwitchProTrackLevelsHistory => ({
    request: {
      url: `/protrack-levels-progress/${organizationId}/`,
    },
  })
)

export const fetchOrganizationProtrackLevelChanges = request(
  'ORGANIZATIONS/FETCH_ORGANIZATION_PROTRACK_LEVEL_CHANGES',
  (organizationId: number): IFetchOrganizationProtrackLevelChanges => ({
    request: {
      url: `/organization-protrack-level-changes/${organizationId}`,
    },
  })
)

export const postPartnersLinks = request(
  'ORGANIZATIONS/POST_PARTNERS_LINKS',
  ({ organizationId, data }: IPostPartnersLinksParams): IPostPartnersLinks => ({
    request: {
      url: `/organizations/${organizationId}/partners-links`,
      method: 'POST',
      data,
    },
    success: 'Partners Promo Links were successfully saved!',
  })
)

export const toggleOrganizationSprints = request(
  'ORGANIZATIONS/TOGGLE_SPRINTS',
  ({ organizationId, isSprintsActive }: IToggleOrganizationSprintsParams): IToggleOrganizationSprints => ({
    request: {
      url: `/organizations/${organizationId}`,
      method: 'PATCH',
      data: { isSprintsActive },
    },
    success: `Sprints successfully ${isSprintsActive ? 'activated' : 'deactivated'}!`,
  })
)

export const createSprintForOrganization = request(
  'ORGANIZATIONS/CREATE_SPRINT',
  ({ data, organizationId }: ICreateOrUpdateSprintForOrganizationParams): ICreateOrUpdateSprintForOrganization => ({
    request: {
      url: `/organizations/${organizationId}/sprint`,
      method: 'POST',
      data,
    },
    success: 'Sprint successfully created!',
  })
)

export const updateSprintForOrganization = request(
  'ORGANIZATIONS/UPDATE_SPRINT',
  ({ data, organizationId }: ICreateOrUpdateSprintForOrganizationParams): ICreateOrUpdateSprintForOrganization => {
    return {
      request: {
        url: `/organizations/${organizationId}/sprint/${data.id}`,
        method: 'PUT',
        data,
      },
      success: 'Sprint successfully updated!',
    }
  }
)

export const fetchSprintById = request(
  'ORGANIZATIONS/FETCH_SPRINT_BY_ORGANIZATION_ID',
  ({ organizationId, sprintId }: IFetchOrDeleteSprintByIdParams): IFetchSprintByIdPayload => {
    return {
      request: {
        url: `/organizations/${organizationId}/sprint/${sprintId}`,
      },
    }
  }
)

export const deleteSprintById = request(
  'ORGANIZATIONS/DELETE_SPRINT_BY_ORGANIZATION_ID',
  ({ organizationId, sprintId }: IFetchOrDeleteSprintByIdParams): IDeleteSprintByIdPayload => {
    return {
      request: {
        url: `/organizations/${organizationId}/sprint/${sprintId}`,
        method: 'DELETE',
        pendingObject: { organizationId, sprintId },
      },
      success: 'Sprint was successfully deleted!',
    }
  }
)

export const fetchUsersTrigger = createAction('ORGANIZATIONS/FETCH_USERS_TRIGGER', (params: ITriggerFetchUsers) => ({
  params,
}))
export const fetchUsers = request('ORGANIZATIONS/FETCH_USERS', (params: IFetchUsers) => ({
  request: {
    url: `/organizations/${params.id}/users`,
    method: REQUESTS.GET,
    params,
  },
}))

export const fetchUsersByStatusTrigger = createAction('ORGANIZATIONS/FETCH_USERS_BY_STATUS_TRIGGER', () => {})
export const fetchUsersByStatus = request(
  'ORGANIZATIONS/FETCH_USERS_BY_STATUS',
  ({ id, team, tabType, search }: IFetchUsersByStatus) => ({
    request: {
      url: `/organizations/${id}/users/filters`,
      method: REQUESTS.GET,
      params: { team, tabType, search },
    },
  })
)

export const filterUsersByForAdmin = createAction('ORGANIZATIONS/USERS_FILTER_BY_FOR_ADMIN', (by: any) => by)

export const fetchAllOrganizationUsers = request('ORGANIZATIONS/FETCH_ALL_USERS', organizationId => ({
  request: {
    url: `/users`,
    method: REQUESTS.GET,
    params: { organizationId },
  },
}))

export const deleteOrganizationUser = request('ORGANIZATIONS/USERS/DELETE', ({ id, reason }) => ({
  request: {
    url: `/users/${id}`,
    method: 'DELETE',
    data: { reason },
  },
  success: 'User deleted successfully.',
}))

export const updateUserEmailForReviews = request('ORGANIZATIONS/USER_EMAIL_FOR_REVIEWS', ({ userId, email }) => ({
  request: {
    url: `users/${userId}`,
    method: 'PUT',
    data: { email },
  },
  fail: "Updating user's email was failed",
  success: "Updating user's email was successfully",
}))

// data is
// {
//   entireOrg: bool,
//   teams: [string],
//   proTrackLevelId: number,
//   emails: [string],
//   organizationId: number,
// }
export const manageProTrackLevels = createAction('ORGANIZATIONS/USERS/MANAGE_PROTRACKLEVELS', (data: any) => data)

export const deleteOrganizationUserRole = request(
  'ORGANIZATIONS/DELETE_USER_ROLE',
  ({ organizationId, userId, roleNameForRemove }) => ({
    request: {
      url: `/organizations/${organizationId}/users/roles/user/${userId}`,
      method: 'DELETE',
      data: { roleNameForRemove },
    },
    success: 'Role delete successfully.',
    fail: 'Role delete fail.',
  })
)

export const deleteOrganizationUserBulkForMicroactionTable = request(
  'ORGANIZATIONS/USER_DELETE_BULK_MICROACTION_TABLE',
  ({ userIds, from }: IDeleteOrganizationUserBulk) => ({
    request: {
      url: `/users`,
      method: 'DELETE',
      data: { userIds, from },
    },
    success: 'User(s) delete successfully.',
    fail: 'User(s) delete fail.',
  })
)
